// Working
import React, { useState } from "react";
import { useGetIdentity, useCreate } from "@refinedev/core";
import { Form, FormProps, Input, Modal, ModalProps } from "antd";

import { getRandomName } from "utility";
import { User } from "types";

type CreateCanvasProps = {
  modalProps: ModalProps;
  formProps: FormProps;
};

export const CreateCanvas: React.FC<CreateCanvasProps> = ({
  modalProps,
  formProps,
}) => {
  const { data: user } = useGetIdentity<User | null>();
  const { mutate } = useCreate();

  const [values, setValues] = useState(() => {
    const name = getRandomName();
    return {
      name,
      id: name.replace(/\s/g, "-").toLowerCase(),
      is_featured: false,
    };
  });

  return (
    <Modal
      {...modalProps}
      title="Create Canvas"
      width={600}
      centered
      afterClose={() => {
        const name = getRandomName();
        setValues({
          name,
          id: name.replace(/\s/g, "-").toLowerCase(),
          is_featured: false,
        });
      }}
      bodyStyle={{ borderRadius: "6px" }}
    >
      <Form
        {...formProps}
        labelCol={{ span: 6 }}
        wrapperCol={{ span: 12 }}
        onFinish={() => {
          const canvas = { ...values, user_id: user?.id };
          formProps.onFinish && formProps.onFinish(canvas);
          mutate({
            resource: "shapes",
            values: { canvas_id: values?.id, user_id: user?.id },
            meta: { canvas },
            successNotification: false,
          });
        }}
      >
        <Form.Item label="ID:">
          <Input value={values.id} disabled />
        </Form.Item>

        <Form.Item label="Name:">
          <Input value={values.name} disabled />
        </Form.Item>
      </Form>
    </Modal>
  );
};
